<template>
  <div>
    <div class="section-title">
      <h3>{{ type.toString() === '1' ? 'Toma' : 'Salida' }} de muestras</h3>
      <p class="ml-auto has-text-weight-semibold">{{ sampleCountLabel }}</p>
      <a
          v-if="scanErrors.length"
          class="ml-3"
          href="#"
          @click.prevent="showErrorsModal = true"
      >{{ scanErrorsLinkLabel }}</a>
    </div>
    <div class="content">
      <b-message v-if="specialFunctionsMessage" :type="specialFunctionsMessageType || 'is-warning'">
        {{ specialFunctionsMessage }}
      </b-message>
      <form @submit.prevent="onSubmit">
        <b-field
            v-if="type.toString() === '1'"
            label="Por orden"
            :type="byOrden && orderNew ? 'is-info' : null"
            :message="byOrden && orderNew ? ('Lote restringido a la orden ' + orderNew) : null"
        >
          <b-checkbox v-model="byOrden"/>
        </b-field>
        <b-field
            label="Código de Muestra"
            :type="sampleMessageType || null"
            :message="sampleMessage"
        >
          <b-input
              ref="sampleInput"
              v-model="sample"
              type="text"
              maxlength="12"
              autocomplete="off"
              inputmode="numeric"
              pattern="[0-9]*"
          />
        </b-field>
        <p v-if="scanErrors.length" class="help">
          <a href="#" @click.prevent="showErrorsModal = true">{{ scanErrorsLinkLabel }}</a>
        </p>
      </form>
      <div v-if="enableSpecialFunctions" class="mt-2">
        <h6 class="subtitle">Acciones</h6>
        <div class="columns">
          <div class="column is-3">
            <b-field
                label="Quitar marca de cancelado"
                :type="removeCancel ? 'is-warning' : null"
                :message="removeCancel ? 'Se permitirá agregar muestras de órdenes canceladas' : null"
            >
              <b-checkbox v-model="removeCancel"/>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field label="Requiere cambio Fecha de la Orden">
              <b-checkbox v-model="requireUpdateDate"/>
            </b-field>
          </div>
          <div class="column is-4" v-if="requireUpdateDate">
            <b-field
                label="Fecha de la Orden"
                :type="ordersDateMessageType || null"
                :message="ordersDateMessage"
            >
              <input class="input" type="date" v-model="ordersDate"/>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <form @submit.prevent="onSend">
        <b-button type="is-primary is-fullwidth" native-type="submit">Enviar Lote</b-button>
      </form>
    </div>
    <div class="content">
      <b-message v-if="lotMessage" :type="lotMessageType || 'is-danger'">
        {{ lotMessage }}
      </b-message>
      <p class="has-text-weight-semibold mb-2">
        {{ sampleCountLabel }}
        <a
            v-if="scanErrors.length"
            class="ml-3 has-text-weight-normal"
            href="#"
            @click.prevent="showErrorsModal = true"
        >{{ scanErrorsLinkLabel }}</a>
      </p>
      <div class="activity-items">
        <b-table
            :data="data"
            striped
            :loading="loading"
            :row-class="getRowClass"
        >
          <b-table-column field="action" label="Acciones" v-slot="props">
            <b-button
                @click="onDropItem(props.row.code)">
              <b-icon
                  icon="window-close"
                  size="is-small">
              </b-icon>
            </b-button>
          </b-table-column>
          <b-table-column field="code" label="Código" searchable sortable v-slot="props">
            {{ props.row.code }}
          </b-table-column>

          <b-table-column field="fullname" label="Paciente" searchable sortable v-slot="props">
            {{ props.row.patient && props.row.patient.full_name }}
          </b-table-column>

          <b-table-column field="birthday" label="Fecha de Nacimiento" sortable v-slot="props">
            {{ props.row.patient && props.row.patient.birthday }}
          </b-table-column>

          <b-table-column field="container.name" label="Contenedor" searchable sortable v-slot="props">
            {{ props.row.container && props.row.container.name }}
          </b-table-column>


          <b-table-column field="bio_material.name" label="Material Biologico" searchable sortable v-slot="props">
            {{ props.row.bio_material && props.row.bio_material.name }}
          </b-table-column>

          <b-table-column field="status" label="Estado" sortable v-slot="props">
            <div>{{ props.row.status }}</div>
            <p v-if="rowError(props.index)" class="help is-danger">{{ rowError(props.index) }}</p>
          </b-table-column>

        </b-table>
      </div>
    </div>
    <div class="content">
      <form @submit.prevent="onSend">
        <b-button type="is-primary is-fullwidth" native-type="submit">Enviar Lote</b-button>
      </form>
    </div>
    <div class="content">
      <router-link class=""
                   :to="{name:'io-samples'}">
        Regresar
      </router-link>
    </div>
    <scan-errors-modal
        :active="showErrorsModal"
        :errors="scanErrors"
        :title="errorsModalTitle"
        @close="showErrorsModal = false"
        @clear="clearScanErrors"
    />
  </div>
</template>

<script>
import ScanErrorsModal from '@/components/io-sample/ScanErrorsModal.vue';

export default {
  name: "Create",
  components: {ScanErrorsModal},
  props: {
    type: Number | String
  },
  data() {
    return {
      sample: '',
      loading: false,
      data: [],
      columns: [
        {
          field: 'code',
          label: 'Código',
          searchable: true,
        },
        {
          field: 'patient.full_name',
          label: 'Paciente',
          searchable: true,
        },
        {
          field: 'patient.birthday',
          label: 'Fecha de Nacimiento',
          searchable: true,
        },
        {
          field: 'container.name',
          label: 'Contenedor',
          searchable: true
        },
        {
          field: 'bio_material.name',
          label: 'Material Biológico',
          searchable: true
        },
        {
          field: 'status',
          label: 'Estado'
        }
      ],
      apiUrl: 'lots',
      errors: {},
      byOrden: false,
      orderNew: '',
      enableSpecialFunctions: false,
      removeCancel: false,
      requireUpdateDate: false,
      ordersDate: null,
      sampleMessage: '',
      sampleMessageType: '',
      ordersDateMessage: '',
      ordersDateMessageType: '',
      lotMessage: '',
      lotMessageType: '',
      specialFunctionsMessage: '',
      specialFunctionsMessageType: '',
      scanMessageTimer: null,
      showErrorsModal: false,
      pendingCodes: {}
    }
  },
  computed: {
    storegeKey() {
      const extra = this.type.toString() !== '2' ? '.1' : '';
      return 'io-samples.lot' + extra;
    },
    sampleCountLabel() {
      const total = Array.isArray(this.data) ? this.data.length : 0;
      return total === 1 ? '1 muestra en este lote' : `${total} muestras en este lote`;
    },
    scanErrors() {
      const key = this.type.toString() === '2' ? '2' : '1';
      return this.$store.state.ioSamples.errorsByType[key] || [];
    },
    scanErrorsLinkLabel() {
      const total = this.scanErrors.length;
      return total === 1 ? 'Ver detalle de 1 error' : `Ver detalle de ${total} errores`;
    },
    errorsModalTitle() {
      return this.type.toString() === '1'
          ? 'Errores de toma de muestras'
          : 'Errores de salida de muestras';
    }
  },
  watch: {
    sample(val) {
      const digits = this.sampleDigits(val);
      if (String(val == null ? '' : val) !== digits) {
        this.sample = digits;
        return;
      }
      if (digits) {
        this.clearSampleMessage();
      }
    },
    ordersDate() {
      this.clearOrdersDateMessage();
    },
    requireUpdateDate(val) {
      if (!val) {
        this.clearOrdersDateMessage();
      }
    }
  },
  mounted() {
    this.prepareComponent();
  },
  beforeDestroy() {
    this.clearScanMessageTimer();
  },
  methods: {
    clearScanMessageTimer() {
      if (this.scanMessageTimer) {
        clearTimeout(this.scanMessageTimer);
        this.scanMessageTimer = null;
      }
    },
    focusSampleInput() {
      this.$nextTick(() => {
        const input = this.$refs.sampleInput;
        if (input && input.focus) {
          input.focus();
        }
      });
    },
    recordError(error) {
      this.$store.dispatch('ioSamples/addError', {
        type: this.type,
        error: error || {}
      });
    },
    recordSendErrors(errors) {
      const fieldErrors = (errors && errors.errors) || {};
      const keys = Object.keys(fieldErrors);
      if (!keys.length) {
        this.recordError({
          code: '',
          message: this.getErrorMessage(errors),
          source: 'send',
          level: 'is-danger'
        });
        return;
      }
      keys.forEach((key) => {
        const idx = key.split('.')[1];
        const row = this.data[idx];
        const val = fieldErrors[key];
        const text = Array.isArray(val) ? val.join(' ') : val;
        this.recordError({
          code: row && row.code ? row.code : '',
          message: text || this.getErrorMessage(errors),
          source: 'send',
          level: 'is-danger'
        });
      });
    },
    clearScanErrors() {
      this.$store.dispatch('ioSamples/clearErrors', this.type);
      this.showErrorsModal = false;
    },
    rejectScan(type, text, withToast) {
      const code = this.sample;
      if (withToast) {
        this.$toast.error(text, 500);
      }
      this.setSampleMessage(type, text);
      this.recordError({
        code: code,
        message: text,
        level: type || 'is-danger',
        source: 'scan'
      });
      this.sample = '';
      this.focusSampleInput();
      this.clearScanMessageTimer();
      const messageText = text;
      this.scanMessageTimer = setTimeout(() => {
        if (this.sampleMessage === messageText) {
          this.clearSampleMessage();
        }
        this.scanMessageTimer = null;
      }, 4000);
    },
    setSampleMessage(type, text) {
      this.sampleMessageType = type || '';
      this.sampleMessage = text || '';
    },
    clearSampleMessage() {
      this.sampleMessage = '';
      this.sampleMessageType = '';
    },
    setOrdersDateMessage(type, text) {
      this.ordersDateMessageType = type || '';
      this.ordersDateMessage = text || '';
    },
    clearOrdersDateMessage() {
      this.ordersDateMessage = '';
      this.ordersDateMessageType = '';
    },
    setLotMessage(type, text) {
      this.lotMessageType = type || '';
      this.lotMessage = text || '';
    },
    clearLotMessage() {
      this.lotMessage = '';
      this.lotMessageType = '';
    },
    getErrorMessage(error) {
      const network = 'No se pudo conectar. Verifique la red e intente de nuevo.';
      const fallback = 'No se pudo completar la operación. Intente de nuevo o contacte a soporte.';
      if (!error) {
        return fallback;
      }
      if (typeof error === 'string') {
        return error || fallback;
      }
      if (error.name === 'TypeError' || error instanceof TypeError) {
        return network;
      }
      const msg = error.message || (error.response && error.response.data && error.response.data.message) || '';
      if (!msg) {
        return fallback;
      }
      if (msg === 'Network Error' || /network|timeout|ECONN/i.test(msg)) {
        return network;
      }
      if (/Cannot read|undefined/.test(msg) && !error.status && !error.errors) {
        return network;
      }
      if (typeof msg === 'string' && msg.trim().charAt(0) === '<') {
        return fallback;
      }
      return msg;
    },
    isSamplePayloadComplete(sample) {
      return !!(sample
          && sample.id
          && sample.order
          && sample.order.order_new
          && sample.patient
          && sample.container
          && sample.bio_material);
    },
    sampleDigits(value) {
      return String(value == null ? '' : value).replace(/\D/g, '');
    },
    sampleCodeLength(value) {
      return this.sampleDigits(value).length;
    },
    codesMatch(a, b) {
      const da = this.sampleDigits(a);
      const db = this.sampleDigits(b);
      if (!da || !db) {
        return false;
      }
      if (da === db) {
        return true;
      }
      const strip = (value) => value.replace(/^0+/, '') || '0';
      if (strip(da) === strip(db)) {
        return true;
      }
      const body = (value) => (value.length === 12 ? value.slice(0, 11) : value);
      return strip(body(da)) === strip(body(db));
    },
    isCodeInLot(code) {
      return this.data.some((item) => this.codesMatch(item.code, code));
    },
    isCodePending(code) {
      return Object.keys(this.pendingCodes).some((pending) => this.codesMatch(pending, code));
    },
    prepareComponent() {
      if (this.type == 1) {
        this.$loader.show();
        this.$http.get('/lots/branchs/special-functions').then(({data}) => {
          this.enableSpecialFunctions = data.enabled;
          this.specialFunctionsMessage = '';
          this.specialFunctionsMessageType = '';
        }).catch(() => {
          this.enableSpecialFunctions = false;
          this.specialFunctionsMessage = 'No se pudieron cargar las acciones especiales';
          this.specialFunctionsMessageType = 'is-warning';
        }).finally(() => {
          this.$loader.hide();
        })
      }
      let data = localStorage.getItem(this.storegeKey);
      if (data) {
        try {
          data = JSON.parse(data);
          if (Array.isArray(data)) {
            this.data = data;
          }
        } catch {
          this.setLotMessage('is-warning', 'No se pudo recuperar el lote en captura');
        }
      }
    },
    async onSubmit() {
      this.errors = {};
      this.clearLotMessage();
      const code = this.sampleDigits(this.sample);
      if (!code) {
        this.rejectScan('is-danger', 'El código de la muestra es requerido', true);
        return;
      }
      const codeLength = this.sampleCodeLength(code);
      if (codeLength < 11 || codeLength > 12) {
        this.rejectScan('is-danger', 'El código debe tener 11 o 12 dígitos', true);
        return;
      }
      if (this.isCodePending(code)) {
        return;
      }
      if (this.isCodeInLot(code)) {
        console.error('Ese código ya está registrado para ser enviado');
        this.rejectScan('is-danger', 'El código ya está registrado para ser enviado', true);
        return;
      }
      this.$set(this.pendingCodes, code, true);
      this.loading = true;
      const params = {};
      if (this.type == 1) {
        if (this.removeCancel) {
          params['remove_cancel'] = 1;
        }
      }
      this.fetchData('get', `sample-exists/${code}/${this.type}`, {params}).then(response => {
        const sample = response.sample;
        if (!this.isSamplePayloadComplete(sample)) {
          this.rejectScan('is-danger', 'La muestra no tiene datos completos (paciente, recipiente o material).');
          return;
        }
        let allow = true;
        if (this.type.toString() === '1' && this.byOrden) {
          if (!this.orderNew) {
            this.orderNew = sample.order.order_new
          }
          if (sample.order.order_new !== this.orderNew) {
            allow = false;
          }
          if (!response.active) {
            this.$buefy.dialog.alert({
              title: 'Orden Cancelada',
              message: "La muestra indicada pertenece a una orden cancelada"
            });
            this.setSampleMessage('is-warning', 'La muestra indicada pertenece a una orden cancelada');
            this.recordError({
              code: code,
              message: 'La muestra indicada pertenece a una orden cancelada',
              level: 'is-warning',
              source: 'scan'
            });
          }
        }
        if (allow) {
          if (this.isCodeInLot(code) || this.isCodeInLot(sample.code)) {
            this.rejectScan('is-danger', 'El código ya está registrado para ser enviado', true);
            return;
          }
          this.data.unshift(Object.assign({}, sample, {code: sample.code || code, status: 'Pendiente'}));
          this.data = Object.assign([], this.data);
          this.sample = '';
          this.focusSampleInput();
          localStorage.setItem(this.storegeKey, JSON.stringify(this.data));
          let isFast = false;
          try {
            isFast = this.$alfalab.isIOSamplesFast(this, this.type.toString());
          } catch (e) {
            this.setSampleMessage('is-warning', 'No se pudo leer la configuración de envío rápido');
          }
          if (isFast) {
            this.onSend();
          } else if (!this.sampleMessage) {
            this.setSampleMessage('is-success', 'Muestra agregada al lote');
          }
        } else {
          this.rejectScan('is-danger', 'Solo se pueden agregar muestras de una misma orden', true);
        }
      }).catch(error => {
        this.$alfalab.showError(error)
        this.rejectScan('is-danger', this.getErrorMessage(error));
      }).finally(() => {
        Object.keys(this.pendingCodes).forEach((pending) => {
          if (this.codesMatch(pending, code)) {
            this.$delete(this.pendingCodes, pending);
          }
        });
        this.loading = Object.keys(this.pendingCodes).length > 0;
      });
    },
    async onSend() {
      this.errors = {};
      this.clearLotMessage();
      this.clearOrdersDateMessage();
      if (this.data.length > 0) {
        this.loading = true;
        const params = {
          type: this.type > 2 ? 2 : this.type,
          samples: this.data
        }
        if(this.type == 1){
          params['remove_cancel'] = this.removeCancel;
          if(this.requireUpdateDate){
            if(!this.ordersDate){
              this.$toast.error('Debe capturar la nueva fecha de la orden', 500);
              this.setOrdersDateMessage('is-danger', 'Debe capturar la nueva fecha de la orden');
              this.recordError({
                code: '',
                message: 'Debe capturar la nueva fecha de la orden',
                source: 'send',
                level: 'is-danger'
              });
              this.loading = false;
              return ;
            }
            params['orders_date'] = this.ordersDate;
          }
        }
        this.storeData(params).then(response => {
          this.data = [];
          localStorage.removeItem(this.storegeKey);
          this.orderNew = '';
          this.clearSampleMessage();
          this.$toast.success('Muestras registradas con éxito');
          this.setLotMessage('is-success', 'Muestras registradas con éxito');
        }).catch(errors => {
          this.$alfalab.showError(errors);
          this.errors = (errors && errors.errors) || {};
          this.recordSendErrors(errors);
          if (this.errors && Object.keys(this.errors).length) {
            this.setLotMessage('is-danger', 'Revise las muestras marcadas en la lista');
          } else {
            this.setLotMessage('is-danger', this.getErrorMessage(errors));
          }
        }).finally(() => {
          this.loading = false;
        })
      } else {
        this.$toast.error('Debe capturar al menos un código de muestra', 500);
        this.setLotMessage('is-danger', 'Debe capturar al menos un código de muestra');
        this.recordError({
          code: '',
          message: 'Debe capturar al menos un código de muestra',
          source: 'send',
          level: 'is-danger'
        });
      }
    },
    onDropItem(code) {
      const pos = this.data.findIndex((item) => {
        return this.codesMatch(item.code, code)
      });
      const nuevo = this.data.slice(0);
      nuevo.splice(pos, 1);
      this.data = nuevo;
      localStorage.setItem(this.storegeKey, JSON.stringify(this.data));
      this.errors = {}
      if (this.data.length === 0) {
        this.orderNew = '';
      }
    },
    rowError(index) {
      if (!this.errors || index === undefined || index === null) {
        return '';
      }
      const prefix = 'samples.' + index;
      const messages = [];
      Object.keys(this.errors).forEach((key) => {
        if (key === prefix || key.toString().indexOf(prefix + '.') === 0) {
          const val = this.errors[key];
          if (Array.isArray(val)) {
            val.forEach((item) => messages.push(item));
          } else if (val) {
            messages.push(val);
          }
        }
      });
      return messages.join(' ');
    },
    getRowClass(row, index) {
      return this.rowError(index) ? 'is-danger' : '';
    }
  }
}
</script>

<style scoped>
</style>
